import React from 'react';
import { useNavigate, useSearchParams } from '@remix-run/react';
import { useRecentlySearched } from '@modules-rocco/search/hook/use-recently-searched';
import { generateURL } from '@modules-rocco/url/api/generate-url';
import { MobileSearchList } from './MobileSearchList';

/**
 * Renders the "Recently Searched" list for mobile view.
 * Allows users to click on a recent search term to perform the search again, or clear the history.
 */
export const MobileSearchPageRecentlySearched: React.FC = () => {
    const { recentlySearched, clearHistory } = useRecentlySearched();
    const [, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const handleSearch = (search: string) => {
        setSearchParams({ search });
        navigate(
            generateURL('/search', {
                search,
            })
        );
    };

    if (recentlySearched.length === 0) {
        return null;
    }

    return (
        <MobileSearchList
            onItemClick={(value: string) => {
                handleSearch(value);
            }}
            title="Recently Searched"
            list={recentlySearched}
            extraItem={
                <button
                    type="button"
                    className="font-medium"
                    onClick={clearHistory}
                >
                    Clear History
                </button>
            }
        />
    );
};
